module.exports = __webpack_public_path__ + "img/japan-genitourinary-diseases-female.76555dea.png";